import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AssessorSummary } from '../Site/Site.Model';
import { HelpContentRendererValue, HelpContentComponent, HelpService } from '../../UI-Lib/Help-Tooltip';

export interface AssessorDetailsComponentParams extends HelpContentRendererValue<AssessorSummary> {
    siteId?: number;
    parcelId?: number;
    stateId: number;
}

@Component({
    selector: 'assessor-details',
    template: `
        <h4 style="margin-top: 0;">
            @if (jurisdictionSpecialists.length > 1) {
                Jurisdiction Specialists
            } @else {
                Jurisdiction Specialist
            }
        </h4>
        <ws-ace-loader
            [show]="loading"
            [marginTop]="0"
            [size]="2"
            [hasOverlay]="false"
            [hideLabel]="true"
        ></ws-ace-loader>
        @for (specialist of jurisdictionSpecialists; track specialist; let first = $first) {
            <div [ngClass]="{ 'specialist-list-item': !first }">
                <div style="font-weight: bold;"
                    >{{ specialist.firstName }} {{ specialist.lastName }}
                    @for (type of specialist.propertyTypes; track type) {
                        <span class="label" [ngClass]="'property-type-' + propertyTypes[type - 1]">{{
                            propertyTypes[type - 1]
                        }}</span>
                    }
                </div>
                <div>{{ specialist.teamName }}</div>
                <div>{{ specialist.address.phone }}</div>
                <div
                    ><a href="mailto:{{ specialist.address.email }}">{{ specialist.address.email }}</a></div
                >
            </div>
        }
        @if (!loading && jurisdictionSpecialists && !jurisdictionSpecialists.length) {
            <div>
                <em>None Assigned</em>
            </div>
        }
    `,
    standalone: false,
})
export class AssessorDetailsComponent implements HelpContentComponent<AssessorDetailsComponentParams> {
    constructor(
        private readonly _http: HttpClient,
        private readonly _helpService: HelpService,
    ) {}

    jurisdictionSpecialists: any[] = [];
    propertyTypes = ['RE', 'PP', 'MN', 'CA'];
    loading: boolean = true;

    params: AssessorDetailsComponentParams;

    async helpInit(params: AssessorDetailsComponentParams): Promise<void> {
        let url = '/api/';
        url += params.siteId ? `site/${params.siteId}` : `parcel/${params.parcelId}`;
        url += `/assessor/${params.value.assessorID}/jurisdictionspecialist`;

        try {
            this.jurisdictionSpecialists = await lastValueFrom(this._http.get<any[]>(url));
        } catch (err) {
            console.log('Loading Jurisdiction Specialist Failed: ', err);
        } finally {
            this.loading = false;
            this._helpService.refresh();
        }
    }
}
